/**
 * Whether the SEO server's head is the head of the current location (web plan
 * W5.1): the URL the document was served for (@/seo/documentHead
 * `servesDocumentHead`). There the root's and the route modules' `meta` render
 * it, so a page renders no head of its own (@/components/seo/PageHead); after
 * an in-app navigation, and without the SEO server, the page's own head is it.
 *
 * Reads the router's contexts directly rather than `useRouteLoaderData`, which
 * throws outside a data router: the pages also render under a plain
 * `<MemoryRouter>` (component tests) or `<BrowserRouter>` (main.tsx), where
 * there is no server head and the page's head is always its own.
 */
import { useContext } from 'react';
import { UNSAFE_DataRouterStateContext, UNSAFE_LocationContext } from 'react-router';
import { servesDocumentHead, type DocumentData } from '@/seo/documentHead';

export function useServesDocumentHead(): boolean {
  const state = useContext(UNSAFE_DataRouterStateContext);
  const location = useContext(UNSAFE_LocationContext)?.location ?? null;
  return servesDocumentHead(state?.loaderData?.root as DocumentData | undefined, location);
}

export default useServesDocumentHead;
